import { types, flow, castToSnapshot } from 'mobx-state-tree';
import { pick } from 'lodash';

import { navigate, makeRequest, url, errorResponse } from 'js/services/Network';
import analytics from 'js/services/Analytics';

import PurchaseToken from '../types/PurchaseToken';
import CreditCard from '../types/CreditCard';
import ShippingDetail from '../types/ShippingDetail';
import Address from '../types/Address';

export default types
  .model('TokenLabelPage', {
    error: types.maybeNull(types.string),
    isSubmitting: false,
    modalIsVisible: false,
    ipAddressesMatchModalIsVisible: false,
    alias: types.string,
    address: types.maybe(Address),
    purchase_token: types.maybe(PurchaseToken),
    credit_card: types.optional(CreditCard, {}),
    shipping_quote: types.maybe(ShippingDetail),
    ip_addresses_check: false,
    ip_addresses_matched: false
  })
  .views(self => ({
    get canSubmit() {
      return !self.ip_addresses_matched;//self.credit_card.isFilledIn;
    },
  }))
  .actions(self => ({
    load: flow(function* load() {
      //analytics.page('SC_reviewed order');
      const response = yield makeRequest('token-label-data', self);

      self.address = response.data.address;
      self.purchase_token = response.data.purchase_token;
      self.credit_card = response.data.credit_card;
      self.shipping_quote = response.data.shipping_quote;

      return response;
    }),

    submit: flow(function* submit() {
      let response;
      if (!self.isSubmitting) {
        self.isSubmitting = true;
        self.error = null;

        try {
          if(!self.ip_addresses_check && window.app.env === 'production'){
            const ipAddressesSameResponse = yield makeRequest('ip-match-check', self);
            if(ipAddressesSameResponse.data){
              //analytics.track('IP addresses are same');
              self.ip_addresses_check = true;
              self.ipAddressesMatchModalIsVisible = true;
              self.ip_addresses_matched = true;
              return false;
            }
          }

          // analytics.track('SC_clicked confirm');
          response = yield makeRequest('token-label', self, pick(self, ['credit_card']));
          navigate(url('status-page', self));
        } catch (error) {
          if (error.response.status === 466) {
            // buyer needs to enter new card, redirect to status page
            navigate(url('status-page', self));
          } else {
            self.error = errorResponse(error);
          }
        }

        self.isSubmitting = false;
      }
      return response;
    }),

    creditCardSaved(creditCard) {
      self.credit_card.setCreditCard(castToSnapshot(creditCard));
      self.modalIsVisible = false;
    },
    editPaymentMethod() {
      //analytics.page('SC_viewed enter cc modal');
      self.modalIsVisible = true;
      return self;
    },
    closeModal() {
      self.modalIsVisible = false;
      self.ipAddressesMatchModalIsVisible = false;
      self.isSubmitting = false;
      return self;
    },
    closeIpAddressesMatchModal(){
      this.closeModal();
      self.isSubmitting = false;
      return self;
    }
  }));
